import React, {useContext} from "react";
import { useIsFocused } from "@react-navigation/native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";

import { styleVars } from "../../app-style-vars";
import { screensConfig } from "../../screens/screensConfiguration";
import PtIcon from "../core/pt-icon/pt-icon";
import SubScreensNavigation from "./SubScreensNavigation";
import {getTranslation} from "../../helpers/getTranslation";
import {Platform, TouchableOpacity, View, StyleSheet} from "react-native";
import PtText from "../core/pt-text/pt-text";
import UserContext from "../../helpers/UserContext";

const Tab = createBottomTabNavigator();

export default function TabsNavigation() {

  const getTabButton = (props) => {
    const isFocused = useIsFocused();
    // console.log('the props in touchable = ', props);
    return (
      <TouchableOpacity {...props}>
        <View style={styles.tabBarButtonContainer}>
          <View style={styles.tabBarActiveIndicatorWrapper}>
            <View style={[styles.tabBarActiveIndicator, {backgroundColor: isFocused ? styleVars.boschDarkBlue : 'transparent'},]}/>
          </View>
          <View style={styles.tabBarIconContainer}>
            <PtIcon iconName={props.iconName} iconColor={props.accessibilityState.selected ? styleVars.boschDarkBlue : '#000'} iconSize={styleVars.rem(1.5)} style={{lineHeight: styleVars.rem(1.5)}}/>
          </View>
          <PtText style={[styles.tabBarLabelText, {color: props.accessibilityState.selected ? styleVars.boschDarkBlue : '#000', }]}>{props.tabLabel}</PtText>
        </View>
      </TouchableOpacity>
    )
  };

  const {userData, updateUserData} = useContext(UserContext)

  return (
    <Tab.Navigator
      initialRouteName={'Home'}
      tabBarOptions={{
        activeTintColor: styleVars.boschDarkBlue,
        inactiveTintColor: styleVars.boschDarkGray,
        activeBackgroundColor: 'white',
        inactiveBackgroundColor: 'white',
        labelPosition: 'below-icon',
        style: {
          marginTop: styleVars.rem(.125),
          borderTopColor: styleVars.boschLightGray,
          height: styleVars.rem(4),
        },
      }}
    >
      {screensConfig.filter((screen) => (!screen.noTabs && screen?.countries[userData.baseSiteUID])).map((screen, idx) => (
        !screen.hasSubscreens ?
          <Tab.Screen
            key={`Screen_${idx}`}
            name={screen.navSlug}
            component={screen.component}
            initialParams={{
              screenTitle: screen.screenTitle,
              headerOptions: screen.headerOptions,
              showCopyright: screen.showCopyright,
              screenData:screen
            }}
            options={{
              title: getTranslation(screen.navTitle),
              tabBarButton: props => getTabButton({...props, iconName:screen.icon, tabLabel: getTranslation(screen.navTitle)})
            }}
          />
          :
          <Tab.Screen
            key={`Screen_${idx}`}
            name={screen.navSlug}
            component={SubScreensNavigation}
            initialParams={{
              mainSlug:screen.navSlug,
              screenTitle: screen.screenTitle,
              headerOptions: screen.headerOptions,
              showCopyright: screen.showCopyright,
              mainComponent: screen.component,
              subScreens: screen.subScreens
            }}
            options={{
              title: getTranslation(screen.navTitle),
              tabBarButton: props => getTabButton({...props, iconName:screen.icon, tabLabel: getTranslation(screen.navTitle)})
            }}
          />
      ))}
    </Tab.Navigator>
  )
}

const styles = StyleSheet.create({
  tabBarButtonContainer: {
    width: '100%',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  tabBarActiveIndicatorWrapper: {
    width:'100%',
    alignSelf: 'center'
  },
  tabBarActiveIndicator: {
    height: 2,
    minWidth: 24,
    marginHorizontal: 16,
  },
  tabBarIconContainer: {
    paddingTop: styleVars.rem(.625),
    height: styleVars.rem(2.125),
  },
  tabBarLabelText: {
    fontSize: styleVars.rem(.625),
    paddingTop: styleVars.rem(.5),
    paddingBottom: styleVars.rem(.625),
    lineHeight: styleVars.rem(.625),
  }
});
